export default "__VITE_ASSET__DdmDcRVf__"